module.exports = __webpack_public_path__ + "static/img/image006.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image006.gif
// module id = Q5dc
// module chunks = 1